import { UserFilter } from "@coaching-culture/types";
import { Box, Text } from "@coaching-culture/ui";
import CenterColumn from "components/CenterColumn";
import { PageHeader } from "components/PageHeader";
import { useAvailableContent } from "queries/mindset";
import { useMemo, useState } from "react";
import { ContentReport } from "./ContentReport";
import { MatrixReport } from "./MatrixReport";

export const LearncastReport = () => {
  const [selected, setSelected] = useState<string>("matrix");
  const { data: content = [] } = useAvailableContent();

  const thisType = useMemo(
    () => content.filter((x) => x.type === "learncast"),
    [content],
  );

  const [filter, setFilter] = useState<UserFilter>({
    groups: [],
    userFields: [],
  });

  const options = [
    {
      value: "matrix",
      label: "Summary By User",
    },
    ...thisType.map((x) => ({
      value: x.id.toString(),
      label: x.name,
    })),
  ];

  const commonProps = {
    options,
    selected,
    filter,
    onChange: setSelected,
    onFilterChange: setFilter,
  };

  return (
    <>
      <CenterColumn>
        <PageHeader
          text="Insights"
          subtitle="An overview of the data collected by the platform"
        />
        <Box>
          <Text mb={3} fontSize="section" fontWeight={600} color="black">
            Learn Cast
          </Text>
          {selected === "matrix" ? (
            <MatrixReport
              {...commonProps}
              type={"learncast"}
              content={thisType}
            />
          ) : (
            <ContentReport
              {...commonProps}
              type="learncast"
              contentId={selected}
            />
          )}
        </Box>
      </CenterColumn>
    </>
  );
};
